import angular from 'angular';
import Vue from 'vue';
import DomainSuperGroups from './DomainSuperGroups.vue';
import SupergroupBreadcrumb from './SupergroupBreadcrumb.vue';

// Register Vue components
Vue.component('DomainSuperGroups', DomainSuperGroups);
Vue.component('SupergroupBreadcrumb', SupergroupBreadcrumb);

// Create Angular module
export default angular.module('adminPanel.adminEntities.domains', [])
  // Register the Vue component as an Angular provider
  .provider('DomainSuperGroups', function() {
    this.$get = function() {
      return DomainSuperGroups;
    };
  })
  .provider('SupergroupBreadcrumb', function() {
    this.$get = function() {
      return SupergroupBreadcrumb;
    };
  })
  .name;